module.exports = __webpack_public_path__ + "static/media/menu-img.dd772039.jpg";